const onlineShopping = {
  'onlineShopping-1': 'Online Shopping',
  'onlineShopping-2': 'Coming soon'
};

export default onlineShopping;
